module.exports = __webpack_public_path__ + "static/img/code.3e8355e.png";


//////////////////
// WEBPACK FOOTER
// ./static/MRMS/images/code.png
// module id = hhsR
// module chunks = 1